export const GOOGLE_AUTH_SCOPE = {
  HISTORY: 'https://www.googleapis.com/auth/webhistory',
  EMAIL: 'https://www.googleapis.com/auth/userinfo.email',
};

export const WEB_HISTORY_STORAGE_KEY = 'suggestions';
export const WEB_HISTORY_CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const WEB_HISTORY_TOP_ITEMS_COUNT = 5;
export const WEB_HISTORY_RANGE_IN_DAYS = 30;
export const GOOGLE_AUTH_COOKIE_EXPIRES_IN_DAYS = 3650;
